export default __webpack_public_path__ + "static/media/fence.7c1958ab.png";